module.exports = __webpack_public_path__ + "images/category_lp/brand/store_images/3_c95c45398cd61d05f6b042b05a507c1c.png";